import { Loader2, Sparkles } from 'lucide-react';

interface AiDraftAssistPanelProps {
  value: string;
  onChange: (value: string) => void;
  onGenerate: () => void;
  isGenerating: boolean;
  error?: string;
  hint: string;
}

export default function AiDraftAssistPanel({
  value,
  onChange,
  onGenerate,
  isGenerating,
  error,
  hint,
}: AiDraftAssistPanelProps) {
  return (
    <div className="card-shell p-3 mb-4 border border-[var(--border-default)] bg-[var(--bg-tertiary)]">
      <div className="flex items-center justify-between gap-2">
        <label className="field-label mb-0">AI Draft Assistant</label>
        <button
          type="button"
          onClick={onGenerate}
          disabled={isGenerating}
          className={`btn-primary-solid flex items-center gap-2 ${isGenerating ? 'opacity-70 pointer-events-none' : ''}`}
        >
          {isGenerating ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />}
          {isGenerating ? 'Generating...' : 'Draft With AI'}
        </button>
      </div>
      <textarea
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
            event.preventDefault();
            onGenerate();
          }
        }}
        className="input-field min-h-[84px] mt-2"
        placeholder="Describe what you need. Include tone, constraints, and campaign context."
      />
      <div className="field-meta">
        <span className="field-hint">{hint}</span>
      </div>
      {error && (
        <div className="field-meta">
          <span className="field-error">{error}</span>
        </div>
      )}
    </div>
  );
}
